<template>
    <div class="appraisal-form-component">
        <div class="task-body">
            <b-form data-vv-scope="appraisal-form">
                <b-form-group
                    label="Judul Penilaian"
                    label-for="title"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="title-appraisal"
                        name="title_appraisal"
                        data-vv-as="Judul penilaian"
                        v-model="appraisal_form.name"
                        type="text"
                        placeholder="Judul Penilaian"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.title_appraisal') }">{{ errors.first('appraisal-form.title_appraisal') }}</span>
                </b-form-group>
                <b-form-group
                    label="Durasi"
                    label-for="duration"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="duration"
                        name="duration"
                        data-vv-as="Durasi"
                        v-model="appraisal_form.duration"
                        type="text"
                        @keypress="isNumber($event)"
                        placeholder="Lama Pengerjaan dalam satuan menit."
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.duration') }">{{ errors.first('appraisal-form.duration') }}</span>
                </b-form-group>
                <b-form-group
                    label="Bentuk Pengerjaan"
                    label-for="type"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-select
                        v-model="appraisal_form.type"
                        name="type"
                        data-vv-as="Bentuk pengerjaan"
                        v-validate="'required'"
                        :options="appraisalType"
                        value-field="id"
                        placeholder="Bentuk Pengerjaan"
                        text-field="name"
                    >
                        <b-form-select-option :value="null" disabled>Please select an option</b-form-select-option>
                    </b-form-select>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.type') }">{{ errors.first('appraisal-form.type') }}</span>
                </b-form-group>
                <!-- <b-form-group
                    label="Awal Pengerjaan"
                    label-for="start_date"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-datepicker
                        id="start-date"
                        v-model="appraisal_form.start_date"
                        name="start_date"
                        data-vv-as="Tanggal awal pengerjaan"
                        v-validate="'required'"
                        class="mb-2"
                    ></b-form-datepicker>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.start_date') }">{{ errors.first('appraisal-form.start_date') }}</span>
                </b-form-group>
                <b-form-group
                    label="Akhir Pengerjaan"
                    label-for="end_date"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-datepicker
                        id="end-date"
                        v-model="appraisal_form.end_date"
                        name="end_date"
                        data-vv-as="Tanggal akhir pengerjaan"
                        v-validate="'required'"
                        class="mb-2"
                    ></b-form-datepicker>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.end_date') }">{{ errors.first('appraisal-form.end_date') }}</span>
                </b-form-group> -->
                <b-form-group
                    label="Petunjuk Pengerjaan"
                    label-for="petunjuk"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-textarea
                        id="tutorial"
                        name="tutorial"
                        data-vv-as="Petunjuk pengerjaan"
                        v-model="appraisal_form.tutorial"
                        placeholder="Enter something..."
                        v-validate="'required'"
                        rows="3"
                        max-rows="6"
                        no-resize
                    ></b-form-textarea>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.tutorial') }">{{ errors.first('appraisal-form.tutorial') }}</span>
                </b-form-group>
                <!-- <b-form-group
                    v-if="appraisalId"
                    label="Terbitkan"
                    label-for="is-publish"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-radio-group
                        id="is-publish"
                        name="is_publish"
                        v-model="appraisal_form.is_publish"
                        :options="options"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.is_publish') }">{{ errors.first('appraisal-form.is_publish') }}</span>
                </b-form-group> -->
                <b-form-group
                    v-if="appraisalId"
                    label="Acak Soal"
                    label-for="is-random-soal"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-radio-group
                        id="is-random-soal"
                        name="is_random_soal"
                        v-model="appraisal_form.is_random_soal"
                        :options="options"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.is_random_soal') }">{{ errors.first('appraisal-form.is_random_soal') }}</span>
                </b-form-group>
                <b-form-group
                    v-if="appraisalId"
                    label="Acak Opsi Soal"
                    label-for="is-random-opsi"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-radio-group
                        id="is-random-opsi"
                        name="is_random_opsi"
                        v-model="appraisal_form.is_random_opsi"
                        :options="options"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('appraisal-form.is_random_opsi') }">{{ errors.first('appraisal-form.is_random_opsi') }}</span>
                </b-form-group>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideAppraisalFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveAppraisal">SIMPAN</b-button>
        </div>
    </div>
</template>
<script>
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            modulId: {
                type: String,
                default: null
            },
            appraisalType: {
                type: Array,
                default: null
            },
            appraisalId: {
                type: String,
                default: null
            },
            appraisalDetail: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                appraisal_form: {
                    learning_activity_id: this.modulId,
                    name: this.appraisalId ? this.appraisalDetail.name : null,
                    tutorial: this.appraisalId ? this.appraisalDetail.tutorial : null,
                    type: this.appraisalId ? this.appraisalDetail.type : null,
                    duration: this.appraisalId ? this.appraisalDetail.duration : null,
                    // start_date: this.appraisalId ? this.appraisalDetail.start_date : null,
                    // end_date: this.appraisalId ? this.appraisalDetail.end_date : null,
                    is_publish: this.appraisalId ? this.appraisalDetail.is_publish : null,
                    is_random_soal: this.appraisalId ? this.appraisalDetail.is_random_soal : null,
                    is_random_opsi: this.appraisalId ? this.appraisalDetail.is_random_opsi : null,
                },
                options: [
                    { item: '1', name: 'Ya' },
                    { item: '0', name: 'Tidak' },
                ]
            };
        },
        methods: {
            resetAppraisalForm() {
                this.appraisal_form.learning_activity_id = this.modulId
                this.appraisal_form.name =  this.appraisalId ? this.appraisalDetail.name : null
                this.appraisal_form.tutorial =  this.appraisalId ? this.appraisalDetail.tutorial : null
                this.appraisal_form.type =  this.appraisalId ? this.appraisalDetail.type : null
                this.appraisal_form.duration =  this.appraisalId ? this.appraisalDetail.duration : null
                // this.appraisal_form.start_date =  this.appraisalId ? this.appraisalDetail.start_date : null
                // this.appraisal_form.end_date =  this.appraisalId ? this.appraisalDetail.end_date : null
                this.appraisal_form.is_publish = this.appraisalId ? this.appraisalDetail.is_publish : 1,
                this.appraisal_form.is_random_soal = this.appraisalId ? this.appraisalDetail.is_random_soal : null,
                this.appraisal_form.is_random_opsi = this.appraisalId ? this.appraisalDetail.is_random_opsi : null,
                this.$validator.reset()
            },
            hideAppraisalFormModal() {
                EventBus.$emit('hideAppraisalFormModal', true)
                this.resetAppraisalForm()
            },
            async saveAppraisal() {
                let scope = 'appraisal-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        if (this.appraisalId) {
                            this.appraisal_form.id = this.appraisalId
                            this.updateAppraisal(scope)
                        } else {
                            this.addAppraisal(scope)
                        }
                    }
                });
            },
            async addAppraisal(scope) {
                this.showLoader = true
                let form = this.appraisal_form
                this.$store.dispatch('addAppraisal', form)
                    .then((res) => {
                        this.showLoader = false
                        let modulId = this.modulId
                        this.$store.dispatch('getAppraisalOverview', { modulId })
                        this.hideAppraisalFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
            async updateAppraisal(scope) {
                this.showLoader = true
                let form = this.appraisal_form
                this.$store.dispatch('updateAppraisal', form)
                    .then((res) => {
                        this.showLoader = false
                        let modulId = this.modulId
                        let quizId = this.appraisalId
                        this.$store.dispatch('getAppraisalOverview', { modulId })
                        this.$store.dispatch('getQuestionOverview', { quizId })
                        this.hideAppraisalFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            }
        },
        created() {
			EventBus.$on('resetAppraisalForm', (val) => {
				if (val) {
					this.resetAppraisalForm()
				}
			})
        }
    }
</script>